import { PayloadAction } from '@reduxjs/toolkit';

import { Draft, DraftState } from '../slice';

const addDraftReducer = (state: DraftState, action: PayloadAction<Draft>) => {
  state.drafts.push(action.payload);
};

export default addDraftReducer;
